import { IconChevronLeft } from '@tabler/icons-react';

export default function TestDraftHeaderSkeleton() {
  return (
    <div className="dark:border-gray-70 flex h-[55px] w-full items-center justify-between border-b border-gray-300 bg-stone-900 px-8 py-3 font-medium">
      <div
        className="flex w-full items-center justify-start space-x-2"
        id="test-draft-header-breadcrumb-column"
      >
        <div className="flex items-center justify-start space-x-2">
          <div className="flex items-center space-x-1 text-sm text-gray-200">
            <IconChevronLeft size={16} />
          </div>
        </div>
        <div className="flex w-full items-center space-x-2 px-4 text-gray-100">
          <div className="flex-shrink-0 text-[13px] font-medium text-gray-300">
            <span>Drafts / </span>
          </div>
          <div className="font-bold">Loading test draft...</div>
        </div>
      </div>
    </div>
  );
}
